const personFormTabs = document.querySelectorAll('.person-company-form__nav-link');
personFormTabs.forEach((personFormTab) => {
  personFormTab.addEventListener('click', () => {
    const parent = personFormTab.closest('.person-company-form');
    const activeTab = parent.querySelector('.person-company-form__nav-link.is-active');
    const id = personFormTab.getAttribute('id');
    const activeContent = parent.querySelector('.person-company-form__tabpanel.is-active');
    const target = parent.querySelector(`.person-company-form__tabpanel.${id}`);

    activeTab.classList.remove('is-active');
    activeContent.classList.remove('is-active');
    personFormTab.classList.add('is-active');
    target.classList.add('is-active');
  });
});

// *******************************************************************************
// Validation
// *******************************************************************************
document.addEventListener('DOMContentLoaded', () => {
  const personForms = document.querySelectorAll('.person-company-form__tabpanel form');
  const companyForm = document.getElementById('company-login-form');

  if (companyForm) {
    const inputsIdNames = [
      '#company_billing_company',
      '#company_taxpayer',
      '#company_billing_address_1',
      '#company_billing_postcode',
      '#company_billing_city',
      '#saop_id',
      '#company_billing_vat',
    ];
    taxNumberInputChecker(companyForm, inputsIdNames);
  }

  personForms.forEach((personForm) => {
    const axiosRegisterAction = (formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, {action: formData.form_action || formData.company_action}).then((token) => {
          const formErrorMessage = personForm.querySelector('.form-error-message');
          formErrorMessage.classList.remove('is-validation-failed');
          formErrorMessage.innerHTML = formErrorMessage.getAttribute('data-generic-error-message');
          const formDataInput = new FormData();
          formDataInput.append('action', formData.person_action || formData.company_action);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {
                window.location.replace(response.data.data.url);
              }
            })
            .catch((err) => {
              formErrorMessage.innerHTML = err.response.data.data.msg;
              formErrorMessage.classList.add('is-validation-failed');
            });
        });
      });
    };

    const fv = FormValidation.formValidation(personForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        company_billing_vat: {
          validators: {
            vat: {
              country: 'SI',
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '',
        });

        FormValidation.utils.classSet(container, {
          'is-validation-failed': !e.valid,
        });
      })
      .on('core.form.valid', () => {
        const formData = {};
        personForm.querySelectorAll('input, textarea').forEach((input) => {
          if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
          } else {
            formData[input.name] = input.value.trim();
          }
        });
        axiosRegisterAction(formData);
      });
    initPostCodeHelper(fv, personForm);
  });
});
